import React, { useState, useEffect } from 'react'
import moment from 'moment';

export const useYears = ( dob ) => {
    
    const [state, setState] = useState( false );
    
    const dobSplit = dob.split('-');
    const todayDate = new Date();

    const dobDate = new Date( `${ dobSplit[0] }/${ dobSplit[1] }/${ dobSplit[2] }` );

    const today = moment( todayDate );
    const dobMoment = moment( dobDate );

    useEffect(() => {
        if( dobSplit.length !== 3 ) {
            setState( false );
            return;
        }
        let dateDiff = today.diff( dobMoment, 'years' );
        setState( dateDiff > 17 );
    }, [dob])
    
    return state;
}
